import iconPath from '@/assets/device-icons/mac-studio.svg';

interface MacStudioIconProps {
  className?: string;
}

export const MacStudioIcon = ({ className = "h-5 w-5" }: MacStudioIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="Mac Studio" 
      className={className}
    />
  );
};
